<script lang="ts">
    import { NEWSLETTER_SIMPLE } from "../scripts/constant";
	import { storeIsOpenNewsletterRegistration, storeNewsletterRegistrationText, storeNewsletterRegistrationTitle, storeNewsletterRegistrationImage } from "../scripts/store";

	function open() {
		storeNewsletterRegistrationTitle.set("inscription&nbsp;à&nbsp;la&nbsp;newsletter");
		storeNewsletterRegistrationText.set("");
		storeIsOpenNewsletterRegistration.set(true);
		storeNewsletterRegistrationImage.set(NEWSLETTER_SIMPLE);
	}

</script>

<style lang="scss">

	.newsletter {
		z-index: 200;
		width: 90%;
		margin: 90px 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border: 1px solid $color_black;
		border-radius: 45px;
		background-color: $color_grey;
		padding: 10px 10px 10px 10px;
		font-family: 'Borna-Medium';
		font-size: 16px;
	}

	.newsexclamation {
		padding: 0 0 0 20px;
	}
	.newsbtn {
		cursor: pointer;
		border: 1px solid $color_black;
		height: 20px;
		border-radius: 20px;
		background-color: $color_white;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		padding: 5px 15px 5px 15px;
		margin: 10px 0 0 0;
		&__text {
			font-family: 'Borna-Medium';
			font-size: 13px;
			padding: 0 4px 0 0;
		}
		&__img {
			width: 8px;
			height: 8px;
		}
		&:hover {
			background-color: $color_primary;
		}
	}

	@include large {
		.newsletter {
			z-index: 2000;
			border-radius: 40px;
			width: 54%;
			max-width: 635px;
			flex-direction: row;
			height: 40px;
		}
		.newsbtn {
			margin: 0 0 0 0;
		}
	}

</style>

<div class="newsletter">
	<div class="newsexclamation">ne ratez plus aucune de nos actualités !</div>
	<div class="newsbtn" on:click={open} on:keydown={open}>
		<div class="newsbtn__text">je m'inscris à la newsletter</div>
		<img class="newsbtn__img" src="../assets/images/btn_recherche_fleche_seule.svg" alt="newsletter">
	</div>
</div>
